import { useMemo, useState } from 'react';
import dayjs from 'dayjs';

export const MOBILE_POPUP_VISIBILITY_KEY = 'MOBILE_POPUP_VISIBILITY';
const LIMIT_DAYS = 7;
const usePopupVisible = () => {
  const parcedData = useMemo(() => {
    const value = localStorage.getItem(MOBILE_POPUP_VISIBILITY_KEY);
    if (!value) {
      return null;
    }
    const date = dayjs(value);
    return date;
  }, []);

  const isVisible = useMemo(() => {
    if (!parcedData) {
      return true;
    }
    const now = dayjs();
    const diff = now.diff(parcedData, 'day');

    return diff > LIMIT_DAYS;
  }, [parcedData]);
  const [visible, setVisible] = useState(isVisible || false);
  const handleChangeVisible = (value: boolean) => {
    setVisible(value);

    if (value === false) {
      localStorage.setItem(MOBILE_POPUP_VISIBILITY_KEY, dayjs().toISOString());
    }
  };
  return {
    visible,
    setVisible: handleChangeVisible,
  };
};

export default usePopupVisible;
